<template>
<div>
 <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-row class="bradcrumb">
        <router-link :to="{name: 'role-links' }" class="root">
            Dashboard
        </router-link> /
        <router-link :to="{name: 'admin-master' }" class="root">
            Admin Master
        </router-link>
        <span class="child">/ Exam Instructions </span>
    </v-row><br />
  <!-- <center class="heading">
        <h3>Add Exam Instructions </h3>
    </center> -->
 <v-card class="card">
      <v-card-title class="heading justify-center">
        <span>Exam Instructions</span>
      </v-card-title>
     <v-card-text>
  <v-data-table
    :headers="headers"
    :items="instlist"
    class="elevation-1 nowrap"
    :search="search"
  >
    <template v-slot:top>
      <v-toolbar flat color="white">
        <v-spacer></v-spacer>
        <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line
            hide-details>
          </v-text-field>
          <span style="width: 20px"></span>
          <template>
            <v-btn class="button" @click="dialog_add=true">Add Instruction</v-btn>
          </template>
       </v-toolbar>
    </template>
         <template v-slot:item.isactive="{ item }">
            <span v-if="item.isactive">
              <v-icon  class="mr-2  v-icon-size" color="success">mdi-check-circle-outline</v-icon>
            </span>
            <span v-else>
              <v-icon  class="mr-2  v-icon-size" color="error">mdi-close-circle-outline</v-icon>
            </span>
          </template>
    <template v-slot:item.action="{ item }">
     <div>
        <v-avatar style="" size="25" class="edit-avatar">
          <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
       </v-avatar>
      </div>
    </template>
  </v-data-table>
    <v-row justify="center">
        <v-form  ref="form" v-model="valid"  lazy-validation  >
        <v-dialog v-model="dialog_add" persistent max-width="600px">
        <v-card>
            <v-card-title class="heading">
            <span class="headline">Add New Instruction</span>
            </v-card-title>
            <v-card-text>
            <v-container>
                <v-row>
                <v-col cols="12" sm="6">
                    <v-autocomplete
                    :items="langList"
                    label="Language*"
                    required
                    item-value="id"
                    item-text="langname"
                    v-model="editedItem.lang"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-autocomplete
                    :items="orgList"
                    item-text="org"
                    item-value="id"
                    label="Organization*"
                    v-model="editedItem.org"
                    required
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-autocomplete
                    :items="examtypeList"
                    label="Exam Type*"
                    v-model="editedItem.et"
                    required
                    item-value="id"
                    item-text="examtype"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-autocomplete
                    :items="eetList"
                    item-text="eetype"
                    item-value="id"
                    label="Exam Enviornment Type*"
                    v-model="editedItem.eet"
                    required
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                    <v-text-field placeholder="Enter Instruction Number"  type="number" hint="Instruction Number" v-model="editedItem.instno"></v-text-field>
                </v-col>
                
                <v-col cols="12">
                    <br><br>
                    <v-textarea placeholder="Enter Instruction" hint="Exam Instruction" v-model="editedItem.inst" height="20px" required></v-textarea>
                </v-col>
                </v-row>
            </v-container>
            <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="button-cancel" text @click="dialog_add=false">Close</v-btn>
            <v-btn class=" button" text @click="save">Save</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
        </v-form>
    </v-row>
    <v-row justify="center">
        <v-form  ref="form" v-model="valid"  lazy-validation  >
        <v-dialog v-model="dialog_edit" persistent max-width="600px">
        <v-card>
            <v-card-title class="heading">
            <span>Edit Instruction</span>
            </v-card-title>
            <v-card-text>
            <v-container>
                <v-row>
                <v-col cols="12" sm="6">
                    <v-autocomplete
                    :items="langList"
                    label=update.uplang
                    required
                    item-value="id"
                    item-text="langname"
                    v-model="langdef.id"
                    
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-autocomplete
                    :items="orgList"
                    item-text="org"
                    item-value="id"
                    label="Organization*"
                    v-model="orgdef.id"
                    required
                    readonly="true"
                    ></v-autocomplete>    
                </v-col>
                <v-col cols="12" sm="6">
                    <v-autocomplete
                    :items="examtypeList"
                    label="Exam Type*"
                    v-model="etdef.id"
                    required
                    item-value="id"
                    item-text="examtype"
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-autocomplete
                    :items="eetList"
                    item-text="eetype"
                    item-value="id"
                    label="Exam Enviornment Type*"
                    v-model="eetdef.id"
                    required
                    ></v-autocomplete>
                </v-col>
                <v-col cols="12">
                    <v-text-field placeholder="Enter Instruction Number" type="number" hint="Instruction Number" v-model="update.upinstno"></v-text-field>
                </v-col>
                 
                <v-col cols="12">
                    <br><br> <br>
                    <v-textarea placeholder="Enter Instruction" hint="Exam Instruction" v-model="update.upinst" height="10px" required></v-textarea>
                    <br>
                    <v-checkbox
                        v-model="update.upisactiv"
                        label="Is Active"
                    ></v-checkbox>
                </v-col>
               
                </v-row>
            </v-container>
            <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="button-cancel" text @click="dialog_edit=false">Close</v-btn>
            <v-btn class="button" text @click="updatedata">Update</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
        </v-form>
    </v-row>
     </v-card-text>
 </v-card>
</div>
</template>

<script>
import axios from 'axios'
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
  export default {
    data: () => ({
      organization:"",
      valid: false,
    overlay: false,
      errorMsg:{
        roleId:false
      },
      
      langdef:{
          langname:null,
          id:null
      },
      orgdef:{
          org:null,
          id:null
      },
      etdef:{
          examtype:null,
          id:null
      },
      eetdef:{
          eetype:null,
          id:null
      },
      update:{
          upinstno:null,
          upinst:null ,
          upisactiv:false,
          uid:null
      },
      
      valid: true,
      dialog_add:false,
      dialog_edit:false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      search:'',
      dialog: false,
      headers: [
        {
          text: 'Sr. No',align: 'left',sortable: false,value: 'instruction_no',
        },
        {
          text: 'Instruction',align: 'left',sortable: false,value: 'instruction',
        },
        {
          text: 'Organization',align: 'left',sortable: false,value: 'org',
        },
        {
          text: 'Active',align: 'left',sortable: true,value: 'isactive',
        },
        { text: 'Actions', value: 'action', sortable: false },
      ],
      orgList: [],
      langList: [],
      instlist:'',
      examtypeList:[],
      eetList:[],
      editedItem: {
        instno:null,
        inst: null,
        org: null,
        lang: null,
        et: null,
        eet:null  
      },
      
    }),

    mounted(){
       this.onLoad()
     },
    methods: {
    
    editItem (item) {
        this.update.upinstno=item.instruction_no
        this.update.upinst =item.instruction
        this.update.upisactiv=item.isactive
         this.update.uid=item.id
        this.langdef.langname=item.language
        this.langdef.id=item.languageid
        this.orgdef.id=item.orgid
        this.orgdef.org=item.org
        this.etdef.examtype=item.examtype
        this.etdef.id=item.examtypeid
        this.eetdef.id=item.examenviornmenttypeid
        this.eetdef.eetype=item.examenviornmenttype
        this.dialog_edit = true
      },
    onLoad(){
      axios
      .post("AdminImport/addExamInstruction")
      .then(res => {
        if (res.data.msg == "200") {
          //window.alert(res.data.msg)
          if(this.load = true){
            this.orgList = res.data.org_List
            this.langList = res.data.lang_List
            this.instlist=res.data.instruction_list
            this.examtypeList=res.data.et_List
            this.eetList=res.data.eet_List
            this.organization=res.data.org;
          }
        } else {
          window.console.log(res.data.msg)
        }
      })
      .catch(error => {
        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        window.console.log(error);
      })
      .finally(()=>{ 
        var overlay=false;
      });       
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
       },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },
    save () {    
         if(this.editedItem.lang==null){
              this.showSnackbar("#b71c1c", "Select Language !!!");
          }
          else if(this.editedItem.org==null){
              this.showSnackbar("#b71c1c", "Select Organization !!!");
          } 
          else if(this.editedItem.et==null){
              this.showSnackbar("#b71c1c", "Select Exam Type !!!!");
          } 
          else if(this.editedItem.eet==null){
              this.showSnackbar("#b71c1c", "Select Exam Enviornment Type");
          } 
          else if(this.editedItem.instno==null){
              this.showSnackbar("#b71c1c", "Enter Instruction Number !!!");
          } else if(this.editedItem.inst==null)
          {
            this.showSnackbar("#b71c1c", "Enter Instruction !!!");             
          }   
          else{
              //alert("Save Funcation")
                axios
                .post("AdminImport/saveExamInstruction", this.editedItem)
                .then(res => {
                    if (res.data.msg_add == "2001") {
                    this.dialog_add=false
                    this.onLoad()
                    this.showSnackbar("#4caf50","Exam Instruction Add Successfully..."); // show snackbar on success   
                    }
                    else if(res.data.msg_add == "Instruction already Exist!!"){
                        this.dialog_add=false
                        this.onLoad()
                        this.showSnackbar("#b71c1c", 'Instruction already Exist!!'); // show snackbar on error
                    }else{
                        this.dialog_add=false
                        this.onLoad()
                        this.showSnackbar("#b71c1c", res.data.msg_add); 
                    }
                })
                .catch(error => {
                    window.console.log(error);
                });
                    this.close()
          }                     
               
      }, //save()
    updatedata () {  
        //alert("Update :"+this.orgdef.id)  
         if(this.langdef.id==null){
              this.showSnackbar("#b71c1c", "Select Language !!!");
          }
          else if(this.orgdef.id==null){
              this.showSnackbar("#b71c1c", "Select Organization !!!");
          } 
          else if(this.etdef.id==null){
              this.showSnackbar("#b71c1c", "Select Exam Type !!!!");
          } 
          else if(this.eetdef.id==null){
              this.showSnackbar("#b71c1c", "Select Exam Enviornment Type");
          } 
          else if(this.update.upinstno==""){
              this.showSnackbar("#b71c1c", "Enter Instruction Number !!!");
          } else if(this.update.upinst=="")
          {
            this.showSnackbar("#b71c1c", "Enter Instruction !!!");             
          }   
          else{
                let formData = new FormData();
                formData.append("id", this.update.uid);
                formData.append("instno", this.update.upinstno);
                formData.append("inst", this.update.upinst);
                formData.append("isactiv", this.update.upisactiv);
                formData.append("langid", this.langdef.id);
                formData.append("orgid", this.orgdef.id);
                formData.append("eetid", this.eetdef.id);
                formData.append("etdid", this.etdef.id);
                //alert('formData'+formData)
                axios
                .post("AdminImport/editExamInstruction", formData,{
                      headers: {
                        "Content-Type": "multipart/form-data"
                      }
                 })
                .then(res => {
                    if (res.data.msg == "200") {
                    this.dialog_edit=false
                    
                    this.showSnackbar("#4caf50","Exam Instruction Update Successfully..."); // show snackbar on success   
                    }
                    else {
                        this.dialog_edit=false
                        
                        this.showSnackbar("#4caf50","Exam Instruction Update Successfully...") // show snackbar on error
                    }
                    this.onLoad()
                })
                .catch(error => {
                    window.console.log(error);
                });
                    this.close()
          }                     
               
      }, //update()
     
    },
  }
</script>
<style scoped>
.v-text-field {
  padding-top: 0px;
  margin-top: 0px;
}
.v-icon-size{
  font-size: 20px;
}
.edit-avatar{
  transition: 0.3s;
  border: 1px solid #b0bec5;
}
.edit-avatar:hover{
  background-color: #b0bec5;
}
.edit-v-icon{
  padding-left: 6px;
  font-size: 15px;
}
.edit-v-icon:hover{
  color: white;
}
</style>